import React from "react";
import { Link } from "react-router-dom";
import { getBrandName } from "../../Components/getBrandName";
import LandingPage from "../Landing/LandingPage";

const Footer = () => {
  const { normalizedBrand, brandName } = getBrandName();

  return (
    <>
      {/* Footer page*/}
      <LandingPage />
    </>
    // <footer className="footer-container pt-5 px-3 px-md-5">
    //   <div className="container">
    //     {/* Subscribe Section */}
    //     <div className="text-center mb-5">
    //       <h5 className="fw-bold mb-3 footer-text">Subscribe to our Newsletter</h5>
    //       <form className="d-flex flex-column flex-sm-row justify-content-center gap-3" action="">
    //         <input
    //           type="email"
    //           maxLength="50"
    //           required
    //           placeholder="Enter your email"
    //           className="form-control w-100 w-sm-auto rounded-pill px-4 py-2 footer-input"
    //         />
    //         <button type="submit" className="btn footer-btn px-4 py-2 rounded-pill">
    //           Subscribe
    //         </button>
    //       </form>
    //     </div>

    //     {/* Footer Links Section */}
    //     <div className="row gy-5 text-start">
    //       {/* Company */}
    //       <div className="col-6 col-md-3">
    //         <h6 className="fw-bold mb-3 footer-text">Company</h6>
    //         <ul className="list-unstyled small">
    //           <li><Link to="/" className="footer-link">Home</Link></li>
    //           <li><Link to="/about-us" className="footer-link">About Us</Link></li>
    //           <li><Link to="/blog" className="footer-link">Blog</Link></li>
    //           <li><Link to="/faq" className="footer-link">FAQs</Link></li>
    //           <li><Link to="/pricing" className="footer-link">Pricing</Link></li>
    //           {/* <li><Link to="/contact" className="footer-link">Contact Us</Link></li> */}
    //         </ul>
    //       </div>

    //       {/* Policy */}
    //       <div className="col-6 col-md-4">
    //         <h6 className="fw-bold mb-3 footer-text">Help and Legal Desk</h6>
    //         <ul className="list-unstyled small">
    //           <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
    //           <li><Link to="/terms-condition" className="footer-link">Terms & Conditions</Link></li>
    //           {/* <li><Link to="/data-retention" className="footer-link">Data Retention & Deletion</Link></li> */}
    //           {/* <li><Link to="/consent-policy" className="footer-link">Consent Policy</Link></li> */}
    //           {/* <li><Link to="/cookie-policy" className="footer-link">Cookie Policy</Link></li> */}
    //           {/* <li><Link to="/cross-border-data-policy" className="footer-link">Cross-Border Data</Link></li> */}
    //           <li><Link to="/grievance-policy" className="footer-link">Grievance Redressal</Link></li>
    //           {/* <li><Link to="/india-specific-policy" className="footer-link">India Privacy Policy</Link></li> */}
    //           {/* <h6 className="fw-bold mb-2 footer-text">Contact</h6>
    //           <p className="mb-1 small footer-text">103, Sanghi Manor, Yeshwant Niwas Rd, Indore, Madhya Pradesh 452003</p>
    //           <p className="mb-3 small footer-text">hello@{normalizedBrand}.com</p> */}
    //           <li><Link to="/contact" className="footer-link">Contact Us</Link></li>

    //         </ul>
    //       </div>


    //       {/* Contact & Social */}
    //       <div className="col-12 col-md-5">
    //         <h6 className="fw-bold mb-3 footer-text">Follow Us</h6>
    //         <div className="d-flex gap-3 mb-3 fs-5">
    //           <a href="#" className="text-white footer-icon"><i className="bi bi-facebook"></i></a>
    //           <a href="#" className="text-white footer-icon"><i className="bi bi-instagram"></i></a>
    //           <a href="#" className="text-white footer-icon"><i className="bi bi-telegram"></i></a>
    //         </div>
    //         <h6 className="fw-bold mb-2 footer-text">Contact</h6>
    //         <p className="mb-1 small footer-text">103, Sanghi Manor, Yeshwant Niwas Rd, Indore, Madhya Pradesh 452003</p>
    //         <p className="mb-3 small footer-text">hello@{normalizedBrand}.com</p>
    //         <Link to="/contact">
    //           <button className="btn btn-outline-light btn-sm rounded-pill px-4">Contact Us</button>
    //         </Link>
    //       </div>
    //     </div>

    //     {/* Footer Bottom */}
    //     <div className="text-center mt-3 pt-3 pb-3 border-top border-secondary small footer-text">
    //      Copyright © {new Date().getFullYear()} {brandName} All Rights Reserved
    //     </div>
    //   </div>
    // </footer>
  );
};

export default Footer;
